import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** Per-table display choices kept across sessions, keyed by table id. */
export interface iTablePrefsState {
  hiddenColumns: Record<string, string[]>;
  columnOrder: Record<string, string[]>;
  pinnedColumns: Record<string, string[]>;
}

const initialState: iTablePrefsState = {
  hiddenColumns: {},
  columnOrder: {},
  pinnedColumns: {},
};

const toggle = (list: string[] | undefined, key: string) =>
  list?.includes(key) ? list.filter((item) => item !== key) : [...(list ?? []), key];

const tablePrefsSlice = createSlice({
  name: 'tablePrefs',
  initialState,
  reducers: {
    toggleTableColumn(state, action: PayloadAction<{ table: string; key: string }>) {
      const { table, key } = action.payload;
      state.hiddenColumns[table] = toggle(state.hiddenColumns[table], key);
    },
    setTableColumnOrder(state, action: PayloadAction<{ table: string; order: string[] }>) {
      const { table, order } = action.payload;
      state.columnOrder ??= {};
      state.columnOrder[table] = order;
    },
    toggleTablePin(state, action: PayloadAction<{ table: string; key: string }>) {
      const { table, key } = action.payload;
      state.pinnedColumns ??= {};
      state.pinnedColumns[table] = toggle(state.pinnedColumns[table], key);
    },
  },
});

export const { toggleTableColumn, setTableColumnOrder, toggleTablePin } = tablePrefsSlice.actions;
export default tablePrefsSlice.reducer;
